import { css } from 'emotion';

export const title = css`
  margin-bottom: 20px;
`;

export const icon = css`
  margin-right: 10px;
`;

export const overlay = css`
  && {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    min-width: 150px;
    box-sizing: border-box;
    margin: 5px 0;
    padding: 20px;
  }
`;

export const checkbox = css`
  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;
